export default "__VITE_ASSET__CfHPJ91J__"